module.exports = __webpack_public_path__ + "static/leadframe-magazine-fc6a19d828fa46a439b6cdc65d9d8e6d.png";